
export const devCollectLogs = ref<boolean>(false)

export const devLog = ref<any[]>([])

export const devAppendLog = (log: any, type: string) => {
  devLog.value.unshift({
    time: new Date(),
    type,
    log
  })

  // if longer than 100, remove last
  if(devLog.value.length > 100){
    devLog.value.pop()
  }
}

watch(devCollectLogs, (v) => {
  if(v){
    console.log('Collecting logs')
    localStorage.setItem('devCollectLogs', 'true')
  }else{
    console.log('Not collecting logs')
    localStorage.setItem('devCollectLogs', 'false')
  }
})
